<div class="ticket" [class]="status">


  <div class="d-flex justify-content-between">
    <div>
      <span class="ticket-flight_number">LA{{ ticket1?.flightNumber }}</span>
      <span class="ticket-flight_number">LA{{ ticket2?.flightNumber }}</span>
    </div>
    <div class="d-flex gap-1">
      <div>
        <img src="assets/images/airplane_boarding.svg" alt="Avião Partindo"/>
      </div>
      <div>
        <span class="ticket-boarding_date">{{ ticket1?.departureDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
        <span class="ticket-boarding_date">{{ ticket2?.departureDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
      </div>
    </div>
  </div>

  @if (isActive) {
    <div class="d-flex justify-content-end">
      <app-seat-availability [items]="[ticket1!, ticket2!]"></app-seat-availability>
    </div>
  }

  <div class="d-flex justify-content-between">
    <span class="ticket-origin_destiny">{{ ticket1?.departure }}/{{ ticket1?.arrival }}/{{ticket2?.arrival}}</span>
    <div class="d-flex gap-1">
      <div>
        <img src="assets/images/airplane_arrival.svg" alt="Avião Chegando"/>
      </div>
      <div>
        <span class="ticket-arrival_date">{{ ticket1?.arrivalDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
        <span class="ticket-arrival_date">{{ ticket2?.arrivalDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <div class="d-flex gap-1">
      <div>
        <span class="ticket_number">{{ ticket1?.ticketNumber }}</span>
      </div>

      <div class="copy-text" (click)="ticket1 && copyText(ticket1.ticketNumber)" #tooltip="matTooltip" matTooltip="Copiar">
        <img src="assets/images/copy.svg" alt="Copiar Texto">
      </div>
    </div>

    @if (isActive) {
      <div class="d-flex gap-1">
        <a class="web-checking" href="https://www.latamairlines.com/br/pt/check-in"
          target="_blank" rel="noopener noreferrer">
          WEB CHECKING
        </a>
      </div>
    }
  </div>

  <div class="d-flex justify-content-between">
    <div class="d-flex gap-1">
      <span class="ticket-reservation_code">{{ ticket1?.pnrCode }}</span>
      <div class="copy-text" (click)="ticket1 && copyText(ticket1.pnrCode)" #tooltip="matTooltip" matTooltip="Copiar">
        <img src="assets/images/copy.svg" alt="Copiar Texto">
      </div>
    </div>
    @if (isActive) {
      <button class="btn-cancel" (click)="cancelTicket()" >Cancelar</button>
    }
  </div>

</div>
